import type { AllowedFileType } from 'bundles/author-assignment/staff-part/types';
import type { FileUploaderUppy, UppyFile } from 'bundles/grading-common/types/UppyTypes';
import {
  aiGradingFileTypesAudio,
  aiGradingFileTypesVideoOeq,
  mediaMaxSecondsForAiGrading,
} from 'bundles/grading-common/utils/constants';

export type CustomRestrictionHandlerType = (
  file: UppyFile,
  uppy: FileUploaderUppy,
  handleRestrictionFailed: () => void
) => void;

const checkIfAboveMaxLengthForAiGrading = (url: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const hiddenVideoElement = document.createElement('video');
    hiddenVideoElement.style.display = 'none';
    hiddenVideoElement.src = url;

    document.body.appendChild(hiddenVideoElement);

    hiddenVideoElement.onloadedmetadata = () => {
      // Video duration in seconds
      const duration = hiddenVideoElement.duration;

      // Clean up the object URL
      URL.revokeObjectURL(url);
      // Remove the video element from the DOM to clean up
      document.body.removeChild(hiddenVideoElement);

      resolve(duration > mediaMaxSecondsForAiGrading);
    };
  });
};

const videoUploadRestrictionHandler: CustomRestrictionHandlerType = async (file, uppy, handleRestrictionFailed) => {
  const videoBlobUrl = URL.createObjectURL(file.data);

  if (await checkIfAboveMaxLengthForAiGrading(videoBlobUrl)) {
    // Remove the file from Uppy
    uppy.removeFile(file.id);
    uppy.cancelAll();

    // display error for restriction failed
    handleRestrictionFailed();
  }
};

const getAllowedFileTypesForGroups = (allowedFiles: AllowedFileType[]) => {
  if (allowedFiles.includes('ALL')) {
    return [];
  }

  const allowedFileTypes = [];

  if (allowedFiles.includes('VIDEO')) {
    allowedFileTypes.push(...Object.values(aiGradingFileTypesVideoOeq).map((extension) => `.${extension}`));
  }

  if (allowedFiles.includes('AUDIO')) {
    allowedFileTypes.push(...Object.values(aiGradingFileTypesAudio).map((extension) => `.${extension}`));
  }

  return allowedFileTypes;
};

export { checkIfAboveMaxLengthForAiGrading, videoUploadRestrictionHandler, getAllowedFileTypesForGroups };
